import React, { useState } from 'react';
import {
  getMonthlyFrames,
  getQuarterlyFrames
} from 'services/salesperson-kpi/newBusAnalysis';
import PageHeader from 'components/common/PageHeader';
import NewBusinessAnalysisWrapTable from './NewBusinessAnalysisWrapTable';
import NewBusinessAnalysisFilter from './NewBusinessAnalysisFilter';
const NewBusinessAnalysisDashboard = () => {
  const thisYear = new Date().getFullYear();
  const timeMMethod = y => {
    return [
      `May-${y % 100}`,
      `Jun-${y % 100}`,
      `Jul-${y % 100}`,
      `Aug-${y % 100}`,
      `Sep-${y % 100}`,
      `Oct-${y % 100}`,
      `Nov-${y % 100}`,
      `Dec-${y % 100}`,
      `Jan-${(y + 1) % 100}`,
      `Feb-${(y + 1) % 100}`,
      `Mar-${(y + 1) % 100}`,
      `Apr-${(y + 1) % 100}`
    ];
  };

  const timeQMethod = y => {
    return [
      `Q2-${y % 100}`, // May-Jul
      `Q3-${y % 100}`, // Aug-Oct
      `Q4-${y % 100}`, // Nov-Jan
      `Q1-${(y + 1) % 100}` // Feb-Apr
    ];
  };
  const defaultFilter = { year: thisYear, accountManager: 0 };
  const [timeM, setTimeM] = useState(timeMMethod(defaultFilter.year));
  const [timeQ, setTimeQ] = useState(timeQMethod(defaultFilter.year));
  const [filter, setFilter] = useState(defaultFilter);

  const formatQuarterlylHeader = time => {
    const month = time.slice(0, 2);
    const year = time.slice(3);
    return `${month}-${year}`;
  };
  const formatMonthlylHeader = time => {
    const month = time.slice(0, 3);
    const year = time.slice(4);
    return `${month}-${year}`;
  };

  const handleChange = (key, value) => {
    console.log(key, value);
    if (key == 'year') {
      setTimeM(timeMMethod(value));
      setTimeQ(timeQMethod(value));
      setFilter({ ...filter, [key]: value });
    } else {
      setFilter({ ...filter, [key]: value.id });
    }
  };

  return (
    <>
      <PageHeader
        title="New Business Analysis Dashboard"
        description={`Manage and view all available New Business Analysis from this page.`}
        className="mb-3"
      ></PageHeader>
      <NewBusinessAnalysisFilter handleChange={handleChange} filter={filter} />
      <NewBusinessAnalysisWrapTable
        filter={filter}
        times={timeM}
        title={'Monthly'}
        loadDataFunc={getMonthlyFrames}
        formatHeader={formatMonthlylHeader}
        targetValue={40}
      />
      <NewBusinessAnalysisWrapTable
        filter={filter}
        times={timeQ}
        title={'Quarterly'}
        loadDataFunc={getQuarterlyFrames}
        formatHeader={formatQuarterlylHeader}
        targetValue={120}
      />
    </>
  );
};

NewBusinessAnalysisDashboard.propTypes = {};

export default NewBusinessAnalysisDashboard;
